{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "Team",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "title",
    "highlight",
    "members"
  ],
  "properties": {
    "title": {
      "title": "Title",
      "type": "string",
      "maxLength": 120
    },
    "highlight": {
      "title": "Highlighted title part",
      "type": "string",
      "maxLength": 120
    },
    "members": {
      "title": "Members",
      "type": "array",
      "maxItems": 20,
      "x-ui": "list",
      "x-itemTitle": "name",
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "name",
          "role",
          "links"
        ],
        "properties": {
          "photoMediaId": {
            "title": "Photo",
            "type": [
              "string",
              "null"
            ],
            "pattern": "^[0-9a-fA-F-]{36}$",
            "x-ui": "media"
          },
          "name": {
            "title": "Name",
            "type": "string",
            "maxLength": 100
          },
          "role": {
            "title": "Role",
            "type": "string",
            "maxLength": 120
          },
          "links": {
            "title": "Social links",
            "type": "array",
            "maxItems": 6,
            "x-ui": "list",
            "x-itemTitle": "network",
            "items": {
              "type": "object",
              "additionalProperties": false,
              "required": [
                "network",
                "href"
              ],
              "properties": {
                "network": {
                  "title": "Network",
                  "enum": [
                    "instagram",
                    "facebook",
                    "linkedin",
                    "xing",
                    "twitter",
                    "website"
                  ],
                  "x-ui": "select"
                },
                "href": {
                  "title": "Link",
                  "type": "string",
                  "maxLength": 500,
                  "pattern": "^(|page:[0-9a-fA-F-]{36}|/[^\\s]*|https?://[^\\s]+|mailto:[^\\s]+|tel:[+0-9 ]+|#[A-Za-z0-9_-]*)$",
                  "x-ui": "link"
                }
              }
            }
          }
        }
      }
    }
  }
}
